import React from 'react'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


import ivImage01 from '../../../../../images/Software/Windows/InstarVision/Camera_List/Image013.png'
import ivImage02 from '../../../../../images/Software/Windows/InstarVision/Camera_List/Image014.png'

export default function ImageCard() {

  return (
    <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
      <EuiFlexItem>
        <EuiCard
          textAlign="left"
          image={
            <div>
              <img
                src={ivImage01}
                alt="INSTAR InstarVision v2 for Windows"
              />
            </div>
          }
          title="Hinzufügen"
          footer={
            <EuiText>
              <p>Klicken Sie auf den + Button oder führen Sie einen Rechtsklick auf Kamera in der Kamera Liste aus.</p>
            </EuiText>
          }
        />
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiCard
          textAlign="left"
          image={
            <div>
              <img
                src={ivImage02}
                alt="INSTAR InstarVision v2 for Windows"
              />
            </div>
          }
          title="Bearbeiten"
          footer={
            <EuiText>
              <p>Führen Sie einen Rechtsklick auf die Kamera aus, um sie zu bearbeiten.</p>
            </EuiText>
          }
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
}
